/**
 * Phase 1 (試作): OpenAI API 直接呼び出し
 * APIキーは .env.local の REACT_APP_OPENAI_API_KEY に設定
 */

const OPENAI_API_URL = "https://api.openai.com/v1/chat/completions";
const MODEL = "gpt-4o";

/**
 * OpenAI Chat Completions API を呼び出す
 * @param {Array<{role: string, content: string}>} messages - チャット履歴
 * @returns {Promise<string>} - AIのレスポンステキスト
 */
export const callOpenAI = async (messages) => {
  const apiKey = process.env.REACT_APP_OPENAI_API_KEY;
  if (!apiKey) {
    throw new Error(
      "OpenAI APIキーが設定されていません。.env.local に REACT_APP_OPENAI_API_KEY を設定してください。"
    );
  }

  const response = await fetch(OPENAI_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiKey}`,
    },
    body: JSON.stringify({
      model: MODEL,
      messages,
      temperature: 0.3, // 金融系なので低め（より決定論的な回答）
      max_tokens: 2000,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `OpenAI API エラー: ${response.status} ${errorData?.error?.message || response.statusText}`
    );
  }

  const data = await response.json();
  return data.choices?.[0]?.message?.content || "";
};
